import React from 'react';
import ContentLoader from 'react-content-loader';

export const NotificationLoader = ({ width = 340 }: { width?: string | number }) => (
  <div style={{padding: '16px'}}>
    <ContentLoader
      speed={2}
      width={width}
      height={84}
      viewBox="0 0 340 84"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
    >
      <rect x="127" y="48" rx="3" ry="3" width="53" height="11" />
      <rect x="187" y="48" rx="3" ry="3" width="72" height="11" />
      <rect x="11" y="48" rx="3" ry="3" width="100" height="11" />
      <rect x="11" y="68" rx="3" ry="3" width="37" height="11" />
      <rect x="11" y="28" rx="3" ry="3" width="140" height="11" />
      <rect x="166" y="28" rx="3" ry="3" width="173" height="11" />
      <circle cx="10" cy="10" r="10" />
      <rect x="31" y="5" rx="3" ry="3" width="174" height="11" />
    </ContentLoader>
  </div>
);
